import { _defineProperty } from "@slyte/core/src/lyte-utils";
import {Route} from "../../../node_modules/@slyte/router/index.js";
let ModalTestComp;

class ModalTest extends Route {
    render() {
        return { outlet: '#zcatcomponent', component: ModalTestComp };  
    }

    static actions(arg1) {
        return Object.assign(super.actions({

        }), arg1);
    }

    _() {
        _;
    }

    getRequirements() {
        arguments[1].push(import(
            /* webpackChunkName: "components/javascript/zcat-components/modal-test-comp" */
            "../../../components/javascript/zcat-components/modal-test-comp"
        ).then(function(res) {
            ModalTestComp = res.ModalTestComp;
        }));

        
;
    }
}

export {ModalTest};

